export default __webpack_public_path__ + "static/media/vg.37b510b2.svg";